// Copyright 2025. WebPros International GmbH. All rights reserved.

import { Translate } from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery';
import ErrorMessage from 'admin/disasterRecovery/components/ErrorMessage/ErrorMessage';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    compatibilityDetails: IComputeResourceRecoveryReadinessStatusResponse['destination_compute_resources'][number]['compatibility_details'] | null;
}

export default function CapabilitiesConflictDialog({
    isOpen,
    onClose,
    compatibilityDetails,
}: IProps) {
    return (
        <Dialog
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.capabilities" />}
            closeHandler={onClose}
            isOpen={isOpen}
            size={'sm'}
        >
            {!compatibilityDetails?.destination_cr_capabilities_exists && (
                <ErrorMessage>
                    <Translate content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.capabilities.destinationCrCapabilitiesNotExists" />
                </ErrorMessage>
            )}

            {!compatibilityDetails?.destination_cr_os_is_supported && (
                <ErrorMessage>
                    <Translate content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.capabilities.destinationCrOsIsNotSupported" />
                </ErrorMessage>
            )}
        </Dialog>
    );
}